/* eslint-disable unicorn/filename-case -- pre-existing filename convention */
/* eslint-disable jsx-a11y/no-autofocus -- MFA code input requires autofocus for usability */
import { REGEXP_ONLY_DIGITS } from 'input-otp';

import { PinInput } from '@/components/base/input/pin-input';

interface MFACodeInputProps {
  readonly value: string;
  readonly onChange: (value: string) => void;
  readonly onComplete?: (value: string) => void;
  readonly disabled?: boolean;
  readonly shouldAutoFocus?: boolean;
  readonly ariaLabel?: string;
  readonly containerClassName?: string;
  readonly groupClassName?: string;
  readonly slotClassName?: string;
}

/**
 * Reusable 6-digit MFA code input component
 */
export function MFACodeInput({
  value,
  onChange,
  onComplete,
  disabled = false,
  shouldAutoFocus = true,
  ariaLabel = 'Authentication code',
  containerClassName,
  groupClassName,
  slotClassName,
}: MFACodeInputProps) {
  return (
    <PinInput className={containerClassName} disabled={disabled} size="xxs">
      <PinInput.Group
        aria-label={ariaLabel}
        autoComplete="one-time-code"
        autoFocus={shouldAutoFocus}
        containerClassName={groupClassName}
        enterKeyHint="done"
        inputClassName="!text-md"
        inputMode="numeric"
        maxLength={6}
        name="one-time-code"
        pattern={REGEXP_ONLY_DIGITS}
        pushPasswordManagerStrategy="increase-width"
        value={value}
        onChange={onChange}
        onComplete={onComplete}
      >
        <PinInput.Slot className={slotClassName} index={0} />
        <PinInput.Slot className={slotClassName} index={1} />
        <PinInput.Slot className={slotClassName} index={2} />
        <PinInput.Slot className={slotClassName} index={3} />
        <PinInput.Slot className={slotClassName} index={4} />
        <PinInput.Slot className={slotClassName} index={5} />
      </PinInput.Group>
    </PinInput>
  );
}
